var _style, _defs, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetricIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{mask:url(#mask0_4598_333_00000068659617659929599340000008975009234982330555_);}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 18,
    height: 19
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 18,
    height: 19,
    id: "mask0_4598_333_00000068659617659929599340000008975009234982330555_"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.8,13.3L2,12.7l4.2-6.8l2.9,3.4L12.9,3l2.9,4.3L19.2,2L20,2.6l-4.1,6.6L13,4.9l-3.7,6L6.4,7.5L2.8,13.3z  M14.1,18c0.8,0,1.5-0.3,2-0.8c0.6-0.6,0.8-1.2,0.8-2c0-0.8-0.3-1.5-0.8-2c-0.6-0.6-1.2-0.8-2-0.8c-0.8,0-1.5,0.3-2,0.8 c-0.6,0.6-0.8,1.2-0.8,2c0,0.8,0.3,1.5,0.8,2C12.6,17.7,13.3,18,14.1,18z M19.3,21l-2.8-2.8c-0.3,0.3-0.7,0.5-1.1,0.6 C15,18.9,14.6,19,14.1,19c-1.1,0-2-0.4-2.7-1.1c-0.8-0.8-1.1-1.7-1.1-2.7s0.4-2,1.1-2.7c0.8-0.8,1.7-1.1,2.7-1.1s2,0.4,2.7,1.1 c0.8,0.8,1.1,1.7,1.1,2.7c0,0.4-0.1,0.9-0.2,1.3c-0.1,0.4-0.3,0.8-0.6,1.1l2.8,2.8L19.3,21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricIcon);
export default __webpack_public_path__ + "static/media/metric-icon.7da66cafd0eaede45d60de608f7b74d9.svg";
export { ForwardRef as ReactComponent };